import request from '@/apis/request'
const resource = 'game-rounds' 

export default {
  get: (params = {}) => {
    return request.get(`${resource}`, { params })
  }, 
}